import { Sparkles } from 'lucide-react';
import { useDraftMentionStore } from './draftMentionStore';

interface DraftMentionProps {
  draftId: string;
}

export function DraftMention({ draftId }: DraftMentionProps) {
  const openDrawer = useDraftMentionStore((s) => s.openDrawer);

  return (
    <button
      type="button"
      onClick={() => openDrawer(draftId)}
      className="inline-flex items-center gap-1 rounded-md border border-border bg-muted px-1.5 py-0.5 text-[12px] font-medium text-foreground hover:bg-muted/70 focus:outline-none focus:ring-2 focus:ring-ring"
      title={`Open draft ${draftId} for approval`}
    >
      <Sparkles className="h-3 w-3" aria-hidden="true" />
      <code className="font-mono text-[11px]">{draftId}</code>
    </button>
  );
}
